<script>
import { defineComponent, ref } from "@vue/composition-api";
import NavMenu from "./components/NavMenu.vue";
import SmartWiring from "./smartWiring/list/index.vue";
import StationList from "./lineSheet/list/component/stationList.vue";
import LineList from "./lineSheet/list/component/lineList.vue";
import EmailManage from "./emailManage/index.vue";

export default defineComponent({
  name: "Setting",
  components: { NavMenu, SmartWiring, LineList, StationList, EmailManage },
  setup() {
    const activeComponent = ref("SmartWiring");

    const handleSwitchTabs = (val) => {
      activeComponent.value = val;
    };

    return {
      activeComponent,
      handleSwitchTabs,
    };
  },
});
</script>

<template>
  <div class="smart-wiring">
    <NavMenu @on-switch-tabs="handleSwitchTabs" />
    <components :is="activeComponent" />
  </div>
</template>

<style scoped>
#atlwdg-trigger {
  display: none;
}
</style>
